import React from 'react'
import { Icon } from '@iconify/react'

import styles from '../jobApplications.module.css'

const NoSelectUser = () => {
    return (
        <div className={styles.emptyDetail}>
            <div className={styles.emptyDetailCard}>
                <div className={styles.emptyDetailIcon}>
                    <Icon icon="mdi:account-search-outline" width={24} />
                </div>
                <p className={styles.emptyDetailTitle}>Select an applicant</p>
                <p className={styles.emptyDetailText}>
                    Choose a candidate from the list to view their application
                    details and profile.
                </p>
            </div>
        </div>
    )
}

export default NoSelectUser
